import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { EntityDefinitionResource } from "./entity-definition-resource";
import { ListResource } from "./list-resource";

@JsonObject()
export class EntityDefinitionCollectionResource extends ListResource<EntityDefinitionResource> {
    @JsonProperty("items")
    @JsonElementType(EntityDefinitionResource)
    items: Array<EntityDefinitionResource>;
}
